module.exports = __webpack_public_path__ + "static/media/title.6fce6ed5.png";